import groq from "groq";
import navigationFields from "./navigationFields";
import productGroupFields from "./productGroupFields";
import { applyFrench } from "@lib/applyFrenchField";

const siteConfig = groq`
  *[_id == 'global-config'] | order(_updatedAt desc) {
    'title': ${applyFrench("homeTitle", "homeTitle_fr")},
    'description': ${applyFrench("homeDescription", "homeDescription_fr")},
    url,
    logo,
    'brandStory': ${applyFrench("brandStory", "brandStory_fr")},
    announcement {
      'message': ${applyFrench("message", "message_fr")},
      link {
        'link': link.link,
        'handle': link.document->store.slug.current,
        'type': link.document->_type,
        'slug': link.document->slug,
        "productGroup": *[_type=='productPage' && references(^.link.document->_id) ] {
          ${productGroupFields}
        },
      },
      marketOverride [] {
        market,
        'message': ${applyFrench("message", "message_fr")},
        link {
          'link': link.link,
          'handle': link.document->store.slug.current,
          'type': link.document->_type,
          'slug': link.document->slug,
          "productGroup": *[_type=='productPage' && references(^.link.document->_id) ] {
            ${productGroupFields}
          },
        }
      }
    },
    footer-> {
      ${navigationFields}
    },
    navigation[]-> {
      ${navigationFields}
    },
    frontpage -> {
      slug
    },
  }[0]
`;

export default siteConfig;
